import React, {Component} from 'react';
import {navigationAdded} from "../actions/OptionsActions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Loader from "@amzn/meridian/loader";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import ErrorPage from "./utils/ErrorPage";
import Column from "@amzn/meridian/column";
import {
    chainWalk,
    convertToString,
    formQueryParams, getFilteredLocations, getOrDefaultValueForCell,
    missingBagforStowV2
} from "../Utility";
import Link from "@amzn/meridian/link";
import {FormattedMessage} from "react-intl";
import {PackageStatus} from "../enums";
import {getLocale} from "../handler/LocaleHandler";
import {getTableCellCount, getTableCellHeader} from "./utils/TableCellUtil";
import RefreshTimer from "./RefreshTimer";
import {FEATURES} from "../constants";

class AisleV3 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sortColumn: "aisle",
            sortDirection: "ascending"
        }
    }

    render() {
        const {
            loading, error, stowPackageMetricsMap, inductPackageMetricsMap, stowAssociateMetricsMap,
             stowBagMetricsMap, nodeResourceData, stowBinMetricsMapForStowV2, stowCartMetricsMap
        } = this.props;

        if (error) {
            return <ErrorPage errorId="stow.error" errorMessage="Some error occurred"/>
        }

        const allAisles = [
            ...Object.keys(stowPackageMetricsMap),
            ...Object.keys(inductPackageMetricsMap),
            ...Object.keys(stowAssociateMetricsMap),
            ...Object.keys(stowBinMetricsMapForStowV2),
            ...Object.keys(stowBagMetricsMap),
            ...Object.keys(stowCartMetricsMap)
        ];

        const distinctAisles = [...new Set(allAisles)];
        if (loading && !distinctAisles.length) {
            return (
                <Column
                    height="400px"
                    alignmentHorizontal="center"
                >
                    <Loader/>
                </Column>
            );
        }

        let filteredAisles = getFilteredLocations(distinctAisles, stowPackageMetricsMap, this.isDRSStowVisibilityEnabled());
        if(nodeResourceData != null){
            filteredAisles = [
                ...filteredAisles,
                ...Object.keys(nodeResourceData)
            ];
        }
        filteredAisles = [...new Set(filteredAisles)];
        try {
            filteredAisles = filteredAisles.filter(aisles => aisles.startsWith(this.props.navigationOptions[0].value))
        } catch (error) {
            console.error(error);
        }
        const onSort = (sortDetails) => {
            this.setState({
                sortColumn: sortDetails.sortColumn,
                sortDirection: sortDetails.sortDirection
            })
        }
        function customCompare(a, b) {
            return convertToString(a)
                .localeCompare(convertToString(b), getLocale(), {numeric: true});
        }

        const sortColumn = this.state.sortColumn;
        const direction = this.state.sortDirection;
        filteredAisles.sort((a1, a2) => {
            const a1CombinedMetricsMap = this.getCombinedMetricsMap(a1);
            const a2CombinedMetricsMap = this.getCombinedMetricsMap(a2);
            if (direction === "ascending") {
                return customCompare(a1CombinedMetricsMap[sortColumn], a2CombinedMetricsMap[sortColumn])
            } else {
                return customCompare(a2CombinedMetricsMap[sortColumn], a1CombinedMetricsMap[sortColumn])
            }
        });

        return (
            <Column>
                <RefreshTimer deps={[stowBinMetricsMapForStowV2]} />
                <Table headerRows={2} showDividers={false} showStripes={false} spacing="small" fixHeaderRows={true}
                       fixHeaderRowsFullWidth={true}
                       sortColumn={this.state.sortColumn}
                       sortDirection={this.state.sortDirection}
                       onSort={onSort}
                       data-cy={"aisleTable"}>
                    {this.renderHeadings()}
                    {this.renderSubHeadings()}
                    {filteredAisles.map((aisle) => this.renderAisleRow(aisle))}
                </Table>
            </Column>
        )
    }

    renderHeadings() {
        return (
            <TableRow>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="aisle.packages" defaultMessage="Packages"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell/>
                {this.isADTAVisibilityEnabled() && <TableCell/>}
                <TableCell/>
                {this.isCartVisibilityEnabled() && <TableCell/>}
                {this.isCartVisibilityEnabled() && <TableCell>
                    <FormattedMessage id="aisle.carts" defaultMessage="Carts"/>
                </TableCell>}
                {this.isCartVisibilityEnabled() && <TableCell/>}
                <TableCell>
                    <FormattedMessage id="aisle.bags" defaultMessage="Bags"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="aisle.performance" defaultMessage="Performance"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="aisle.stowers" defaultMessage="Stowers"/>
                </TableCell>
            </TableRow>
        )
    }

    renderSubHeadings() {
        return (
            <TableRow>
                <TableCell sortColumn="aisle">
                    <FormattedMessage id="aisle.aisle" defaultMessage="Aisle"/>
                </TableCell>
                <TableCell sortColumn="plannedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.containerPlanned" defaultMessage="C. Planned"/>
                </TableCell>
                <TableCell sortColumn="receivedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.arrived" defaultMessage="Arrived"/>
                </TableCell>
                <TableCell sortColumn="currentInductedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.inducted" defaultMessage="Inducted"/>
                </TableCell>
                {this.isADTAVisibilityEnabled() && getTableCellHeader("currentStowBufferedPackages")}
                <TableCell sortColumn="stowedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.stowed" defaultMessage="Stowed"/>
                </TableCell>
                {this.isCartVisibilityEnabled() &&
                    <TableCell sortColumn="plannedCarts" alignmentHorizontal="right">
                        <FormattedMessage id="aisle.planned_carts" defaultMessage="Planned"/>
                    </TableCell>
                }
                {this.isCartVisibilityEnabled() &&
                    <TableCell sortColumn="usedCarts" alignmentHorizontal="right">
                        <FormattedMessage id="aisle.used_carts" defaultMessage="Used"/>
                    </TableCell>
                }
                {this.isCartVisibilityEnabled() &&
                    <TableCell sortColumn="missingCarts" alignmentHorizontal="right">
                        <FormattedMessage id="aisle.missing_carts" defaultMessage="Missing"/>
                    </TableCell>
                }
                <TableCell sortColumn="plannedBags" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.planned" defaultMessage="Planned"/>
                </TableCell>
                <TableCell sortColumn="usedBags" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.used" defaultMessage="Used"/>
                </TableCell>
                <TableCell sortColumn="binsMissingBag" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.missing" defaultMessage="Missing"/>
                </TableCell>
                <TableCell sortColumn="stowRate" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.stow_rate" defaultMessage="Stow rate"/>
                </TableCell>
                <TableCell sortColumn="scanCompliance" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.scan_complaince" defaultMessage="Scan comp."/>
                </TableCell>
                <TableCell sortColumn="fsaf" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.fsaf" defaultMessage="FSAF"/>
                </TableCell>
                <TableCell sortColumn="activeStowers" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.active" defaultMessage="Active"/>
                </TableCell>
            </TableRow>
        )
    }

    renderAisleRow(aisle) {
        const combinedMetricsMap = this.getCombinedMetricsMap(aisle)
        const stowBufferedCell =
            this.getADTATableCell(combinedMetricsMap.currentStowBufferedPackages, aisle, PackageStatus.CURRENT_STOW_BUFFERED)

        return (
            <TableRow highlightOnHover={true} key={aisle} onClick={() => this.aisleRowClicked(aisle)} data-cy={"aisleDataRow"}>
                <TableCell>{aisle}</TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.plannedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.receivedPackages, aisle, PackageStatus.CURRENT_RECEIVED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.currentInductedPackages, aisle, PackageStatus.CURRENT_INDUCTED)}
                </TableCell>
                {stowBufferedCell}
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.stowedPackages, aisle, PackageStatus.STOWED)}
                </TableCell>
                { this.isCartVisibilityEnabled() && <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.plannedCarts}
                </TableCell>
                }
                { this.isCartVisibilityEnabled() && <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.usedCarts}
                </TableCell>
                }
                { this.isCartVisibilityEnabled() && <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.missingCarts}
                </TableCell>
                }
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.plannedBags}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.usedBags}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.binsMissingBag}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.stowRate}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.scanCompliance}%
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.fsaf}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.activeStowers}
                </TableCell>
            </TableRow>
        )
    }

    getCombinedMetricsMap = aisle => {
        const {
            stowPackageMetricsMap, inductPackageMetricsMap, stowAssociateMetricsMap, stowBinMetricsMapForStowV2, stowBagMetricsMap,
            nodeResourceDataMap, stowCartMetricsMap
        } = this.props;
        const defaultMetricValue = "-"

        return {
            aisle: aisle,
            plannedCarts: getOrDefaultValueForCell(stowCartMetricsMap, aisle, "plannedCarts"),
            usedCarts: getOrDefaultValueForCell(stowCartMetricsMap, aisle, "usedCarts"),
            missingCarts: getOrDefaultValueForCell(stowCartMetricsMap, aisle, "missingCarts"),
            plannedBags: getOrDefaultValueForCell(stowBagMetricsMap, aisle, "plannedBags"),
            usedBags: getOrDefaultValueForCell(stowBagMetricsMap, aisle, "usedBags"),
            binsMissingBag: missingBagforStowV2(nodeResourceDataMap, stowBinMetricsMapForStowV2, aisle),
            plannedPackages: chainWalk(() => stowPackageMetricsMap[aisle].plannedPackages, defaultMetricValue),
            receivedPackages: chainWalk(() => inductPackageMetricsMap[aisle].receivedPackages, defaultMetricValue),
            currentInductedPackages: chainWalk(() => stowPackageMetricsMap[aisle].currentInductedPackages, defaultMetricValue),
            stowedPackages: chainWalk(() => stowPackageMetricsMap[aisle].stowedPackages, defaultMetricValue),
            stowRate: chainWalk(() => stowPackageMetricsMap[aisle].stowRate, defaultMetricValue),
            scanCompliance: chainWalk(() => stowPackageMetricsMap[aisle].scanCompliance, defaultMetricValue),
            currentStowBufferedPackages: chainWalk(() => stowPackageMetricsMap[aisle].currentStowBufferedPackages, defaultMetricValue),
            fsaf: chainWalk(() => stowPackageMetricsMap[aisle].fsaf, defaultMetricValue),
            activeStowers: chainWalk(() => stowAssociateMetricsMap[aisle].activeStowers, defaultMetricValue)
        }
    }

    aisleRowClicked = aisle => {
        this.props.dispatch(navigationAdded({
            key: 'Aisle',
            value: aisle
        }))
    }

    getADTATableCell = (value, aisle, state) => {
        return this.isADTAVisibilityEnabled() && getTableCellCount(this.renderPackageCount(value, aisle, state))
    }

    renderPackageCount = (value, aisle, state) => {
        return value !== 0 && value !== '-' ?
            <Link href={this.getPackageListURL(state, aisle)}
                  type="secondary"> {value} </Link> : value
    }

    getPackageListURL = (state, aisle) => {
        const {navigationOptions, options} = this.props
        const params = {
            PACKAGE_STATUS: state,
            CLUSTER: navigationOptions[0].value,
            AISLE: aisle
        }
        if (options.cycle) {
            params["CYCLE"] = options.cycle;
        }
        return "#packageList/?" + formQueryParams(params);
    }

    isADTAVisibilityEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.ADTA_VISIBILITY];
    }

    isDRSStowVisibilityEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.DRS_STOW_VISIBILITY];
    }

    isCartVisibilityEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.CART_VISIBILITY];
    }
}

const mapStateToProps = state => ({
    loading: state.aisleReducer.loading,
    error: state.aisleReducer.error,
    navigationOptions: state.optionsReducer.navigationOptions,
    options: state.optionsReducer.options,
    stowPackageMetricsMap: state.aisleReducer.stowPackageMetricsMap,
    stowBinMetricsMap: state.aisleReducer.stowBinMetricsMap,
    stowBinMetricsMapForStowV2: state.aisleReducer.stowBinMetricsMapForStowV2,
    stowBagMetricsMap: state.aisleReducer.stowBagMetricsMap,
    stowCartMetricsMap: state.aisleReducer.stowCartMetricsMap,
    inductPackageMetricsMap: state.aisleReducer.inductPackageMetricsMap,
    stowAssociateMetricsMap: state.aisleReducer.stowAssociateMetricsMap,
    nodeResourceData : state.aisleReducer.nodeResourceData,
    nodeResourceDataMap : state.aisleReducer.nodeResourceDataMap,
    featureStatus: state.configReducer.featureStatus
});
export default withRouter(connect(mapStateToProps)(AisleV3));



// WEBPACK FOOTER //
// ./src/components/AisleV3.js